export default "__VITE_ASSET__5538397c__"